// Shopify's exit interstitial skips clicks that are already defaultPrevented; same-tab navigation is still caught, so we open a new tab.
function deskExternalLinksIsTrusted(hostname, domains) {
  hostname = hostname.toLowerCase();
  return domains.some(function (domain) {
    return hostname === domain || hostname.slice(-(domain.length + 1)) === '.' + domain;
  });
}

function deskExternalLinksInit() {
  var config = window.deskExternalLinks;
  if (!config || !config.domains || config.listening) return;

  var domains = config.domains
    .toLowerCase()
    .split(/[\s,]+/)
    .map(function (domain) {
      return domain.replace(/^https?:\/\//, '').replace(/^www\./, '').replace(/\/.*$/, '');
    })
    .filter(function (domain) {
      return /^[a-z0-9-]+(\.[a-z0-9-]+)+$/.test(domain);
    });

  if (!domains.length) return;
  config.listening = true;

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0) return;

    var link = event.target.closest && event.target.closest('a[href]');
    if (!link || (link.protocol !== 'https:' && link.protocol !== 'http:')) return;
    if (link.hostname === location.hostname || !deskExternalLinksIsTrusted(link.hostname, domains)) return;

    event.preventDefault();
    window.open(link.href, '_blank', 'noopener');
  });
}

deskExternalLinksInit();
